import { ApplicationState } from '@app/store'
import { selectSocialNetwork } from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import {
  ISocialConnectionStateProps,
  ISocialConnectionUIProps,
  SocialConnection,
} from '../components/SocialConnection'

export default connect(
  (state: ApplicationState, ownProps: ISocialConnectionUIProps) => {
    return createStructuredSelector<
      ApplicationState,
      ISocialConnectionStateProps
    >({
      socialNetwork: selectSocialNetwork(ownProps.socialConnection.type),
    })(state)
  },
)(SocialConnection)
